
/**
 * Custom component for Bimini Apéritifs menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2022-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2022-05-25 (1.0.0) (jhoward)
 *    - Copy from Romanza_dessert.vue component to Bimini_aperitifs.vue component.
 *
 *  2023-04-17 (1.1.0) (jhoward)
 *    - <Bimini_aperitifs> component uses TypeScript.
 *    - <Bimini_aperitifs> requires the section prop.
 *    - Remove unused methods from <Bimini_aperitifs>.
 *
 *  2023-06-21 (1.2.0) (jhoward)
 *    - Add support for section.ms_show_pricing_header in <Bimini_aperitifs>.
 *
 *  2023-08-23 (1.3.0) (jhoward)
 *    - Use <menu-version> in <Bimini_aperitifs>.
 *
 *  2025-02-11 (1.4.0) (jhoward)
 *    - Add <menu-schedules> to the <Bimini_aperitifs> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <bimini-default-section> in <bimini_aperitifs>.
 */

import {defineComponent, PropType} from "vue";
import {ALLOWED_ITEM_COMPONENTS, Menu, MenuSection} from "../defs";
import BiminiDefaultSection from "./Bimini_defaultSection.vue";

export default defineComponent({
  components: {
    BiminiDefaultSection
  },
  name: "Bimini_aperitifs",
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    menuItemComponent: {
      type: String,
      default: '',
      validate: (value: string) => '' === value || ALLOWED_ITEM_COMPONENTS.indexOf(value)
    },
  },
})
